import { queryOptions, useQuery } from '@tanstack/react-query'
import { settingsApi } from '@/services/settings'
import { useAppSelector } from '@/store/hooks'

const SERVICE_CATEGORY_OPTIONS_STALE_TIME = 5 * 60 * 1000
const SERVICE_CATEGORY_OPTIONS_GC_TIME = 30 * 60 * 1000

export function serviceCategoryOptionsQueryOptions(
  tenantId: string | null | undefined
) {
  return queryOptions({
    queryKey: [
      'settings',
      'service-categories',
      'options',
      tenantId ?? 'unknown-tenant',
    ] as const,
    queryFn: () =>
      settingsApi
        .listServiceCategories({
          limit: 100,
          is_active: true,
          service_items_is_active: true,
          sort_column: 'name',
          sort_order: 'asc',
        })
        .then(response => response.data),
    staleTime: SERVICE_CATEGORY_OPTIONS_STALE_TIME,
    gcTime: SERVICE_CATEGORY_OPTIONS_GC_TIME,
  })
}

export function useServiceCategoryOptions() {
  const tenantId = useAppSelector(state => state.auth.user?.tenant_id)

  return useQuery({
    ...serviceCategoryOptionsQueryOptions(tenantId),
    enabled: Boolean(tenantId),
    select: categories => categories.map(category => category.name),
  })
}

export function useActiveServiceCategories() {
  const tenantId = useAppSelector(state => state.auth.user?.tenant_id)

  return useQuery({
    ...serviceCategoryOptionsQueryOptions(tenantId),
    enabled: Boolean(tenantId),
  })
}
